import React, { useState, useEffect } from 'react';
import SurveyApi from '../../Api/SurveyApi';
import {Form,Input,Select,DatePicker,TimePicker,Button,Row,Col,Card,} from 'antd';
import { toastSuccess, toastError } from '../Toast/ToastComponent';
import { FaArrowLeft } from 'react-icons/fa6';
import style from '../../Styles/AddUser.module.css';
import { useNavigate } from 'react-router-dom';
import { TrainingsApi } from '../../Api/TrainingsApi';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

const CreateTrainings = ({ onBack }) => {
  const [form] = Form.useForm();
  const { edit_id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [departmentIds, setDepartmentIds] = useState([]);
  const [options, setOptions] = useState({
    departments: [],
    trainingTypes: [],
    users: [],
  });
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [deptRes, typeRes] = await Promise.all([
          SurveyApi.getDepartmentDropdown(),
          TrainingsApi.createTraining(),
        ]);

        const dept = deptRes?.data?.result || deptRes?.data || [];
        const types = typeRes?.data?.result || typeRes?.data || [];

        setOptions((prev) => ({
          ...prev,
          departments: dept.map((item) => ({
            label: item.label || item.department_name,
            value: item.value || item.id,
          })),
          trainingTypes: types.map((item) => ({
            label: item.training_type_name || item.name,
            value: item.training_type_name || item.name,
          })),
        }));
        setInitialDataLoaded(true);
      } catch (err) {
        console.log(err);
        toastError('Failed to load data');
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    if (edit_id && initialDataLoaded) {
      const fetchDetails = async () => {
        try {
          const res = await TrainingsApi.getTrainingDetails({
            training_id: edit_id,
          });
          if (res?.data?.success) {
            const data = res.data.result;
            setDepartmentIds([data.department_id]);
            form.setFieldsValue({
              trainingName: data.training_name,
              department: data.department_id,
              trainingType: data.training_type,
              trainingCategory: data.training_category,
              venue: data.venue,
              startDate: data.start_date ? dayjs(data.start_date) : null,
              endDate: data.end_date ? dayjs(data.end_date) : null,
              startTime: data.start_time
                ? dayjs(data.start_time, 'HH:mm:ss')
                : null,
              endTime: data.end_time ? dayjs(data.end_time, 'HH:mm:ss') : null,
              trainers: data.trainers_id || [],
              trainees: data.trainees_id || [],
            });
          }
        } catch (err) {
          toastError('Failed to fetch training details');
        }
      };
      fetchDetails();
    }
  }, [edit_id, initialDataLoaded]);

  useEffect(() => {
    const loadUsers = async () => {
      if (!departmentIds.length) {
        setOptions((prev) => ({ ...prev, users: [] }));
        return;
      }

      try {
        const res = await SurveyApi.getUserDropdown(departmentIds);

        const users = res?.data?.result || [];

        setOptions((prev) => ({
          ...prev,
          users: users.map((u) => ({
            label: u.value,
            value: u.id,
          })),
        }));
      } catch (err) {
        toastError('Failed to load users');
      }
    };

    loadUsers();
  }, [departmentIds]);
  const trainers = Form.useWatch('trainers', form);
  const trainees = Form.useWatch('trainees', form);
  const trainerOptions = options.users.filter(
    (u) => !trainees?.includes(u.value),
  );
  const traineeOptions = options.users.filter(
    (u) => !trainers?.includes(u.value),
  );
  const onFinish = async (values) => {
    console.log(values, 'values');
    setLoading(true);
    try {
      const payload = {
        training_name: values.trainingName,
        training_type: values.trainingType,
        training_category: values.trainingCategory || 'General',
        venue: values.venue,
        department_id: values.department,
        start_date: values.startDate?.format('YYYY-MM-DD'),
        end_date: values.endDate?.format('YYYY-MM-DD'),
        start_time: values.startTime?.format('HH:mm:ss'),
        end_time: values.endTime?.format('HH:mm:ss'),
        trainers_id: values.trainers || [],
        trainees_id: values.trainees || [],
      };
      if (edit_id) {
        await TrainingsApi.updateTraining({ ...payload, id: edit_id });
        toastSuccess('Training Updated Successfully');
      } else {
        await TrainingsApi.createTraining(payload);
        toastSuccess('Training Created Successfully');
      }
      navigate(-1);
    } catch (error) {
      toastError(error.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 20,
        }}
      >
        <div
          className={`${style['arrow-icon']} border px-2 pb-1`}
          onClick={() => navigate(-1)}
          style={{ cursor: 'pointer' }}
        >
          <FaArrowLeft />
        </div>
        <div className={`${style['add-user']} mx-1 mb-0`}>
          {edit_id ? 'Update Training' : 'Create Training'}
        </div>
      </div>
      <Card bordered={false} style={{ borderRadius: '8px' }}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={32}>
            <Col span={12}>
              <Form.Item
                label="Training Name"
                name="trainingName"
                rules={[
                  { required: true, message: 'Training name is required' },
                ]}
              >
                <Input placeholder="Enter Training Name" />
              </Form.Item>
              <Form.Item
                label="Department"
                name="department"
                rules={[{ required: true, message: 'Department is required' }]}
              >
                <Select
                  placeholder="Select Department"
                  options={options.departments}
                  onChange={(val) => {
                    setDepartmentIds([val]);

                    form.setFieldsValue({
                      trainers: [],
                      trainees: [],
                    });

                    setOptions((prev) => ({
                      ...prev,
                      users: [],
                    }));
                  }}
                />
              </Form.Item>
              <Form.Item
                label="Trainers"
                name="trainers"
                rules={[{ required: true, message: 'Select trainers' }]}
              >
                <Select
                  mode="multiple"
                  options={trainerOptions}
                  placeholder="Select trainers"
                />
              </Form.Item>
              <Form.Item
                label="Trainees"
                name="trainees"
                rules={[{ required: true, message: 'Select trainees' }]}
              >
                <Select
                  mode="multiple"
                  options={traineeOptions}
                  placeholder="Select trainees"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Type of Training"
                    name="trainingType"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter training type!',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter or search training type"
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Training Category"
                    name="trainingCategory"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter training category!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Training Category" allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Venue" name="venue">
                    <Input placeholder="Enter Venue" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={6}>
                  <Form.Item
                    label="Start Date"
                    name="startDate"
                    rules={[{ required: true, message: 'Start date required' }]}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Select date"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="End Date"
                    name="endDate"
                    dependencies={['startDate']}
                    rules={[
                      { required: true, message: 'End date required' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const start = getFieldValue('startDate');

                          if (!value || !start) return Promise.resolve();

                          if (value.isBefore(start, 'day')) {
                            return Promise.reject(
                              new Error('End date cannot be before start date'),
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      disabledDate={(current) => {
                        const startDate = form.getFieldValue('startDate');
                        if (!startDate) return false;
                        return current && current < startDate;
                      }}
                      placeholder="Select date"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Start Time"
                    name="startTime"
                    rules={[{ required: true, message: 'Start time required' }]}
                  >
                    <TimePicker
                      format="HH:mm"
                      style={{ width: '100%' }}
                      placeholder="Select time"
                      needConfirm={false}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    shouldUpdate={(prev, curr) =>
                      prev.startTime !== curr.startTime
                    }
                  >
                    {() => {
                      const startTime = form.getFieldValue('startTime');

                      return (
                        <Form.Item
                          label="End Time"
                          name="endTime"
                          rules={[
                            { required: true, message: 'End time required' },
                          ]}
                        >
                          <TimePicker
                            format="HH:mm"
                            style={{ width: '100%' }}
                            needConfirm={false}
                            placeholder="Select time"
                            disabledHours={() => {
                              if (!startTime) return [];

                              const startHour = startTime.hour();

                              // Disable current and previous hours
                              return [...Array(startHour + 1).keys()];
                            }}
                            disabledMinutes={(selectedHour) => {
                              if (!startTime) return [];
                              const startHour = startTime.hour();
                              const startMinute = startTime.minute();
                              if (selectedHour === startHour) {
                                return [...Array(startMinute + 1).keys()];
                              }

                              return [];
                            }}
                          />
                        </Form.Item>
                      );
                    }}
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 10,
              marginTop: 20,
            }}
          >
            <Button onClick={() => navigate(-1)}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {edit_id ? 'Update' : 'Save'}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};
export default CreateTrainings;
